import React from 'react';
import {
  Alert,
  Button,
  FormControlLabel,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  darken,
} from '@mui/material';
import { Box } from '@mui/system';
import { styled } from '@mui/styles';
import {
  CAL_REGISTER_FIELD_CMD,
  CAL_REGISTER_FIELD_CMD_TOGGLE,
} from '../../common/consts';
import TableAvatar from '../TableAvatar';

const TableBox = styled(Box)(({ theme }) => ({
  overflowY: 'scroll',
  overflowX: 'auto',
  maxHeight: 300,
  width: '100%',
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: '4px',
  marginTop: theme.spacing(1),
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
}));

const CalendarCmdSwitch = ({ name, command, cmds, onChange, disabled }) => {
  return (
    <>
      <Typography variant="body2">명령어 실행</Typography>
      <FormControlLabel
        name={name}
        control={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <Switch
            color="secondary"
            checked={!!command || false}
            onChange={onChange}
            disabled={disabled}
          />
        }
        label={
          command
            ? '일정에 맞춰 실행할 명령어를 다음 명령어 목록에서 선택하세요.'
            : '일정과 함께 명령어를 실행하려면 버튼을 선택하세요'
        }
        sx={{ pt: 1.25, pl: 1 }}
      />
      {command && typeof command === 'string' && (
        <Alert icon={false} severity="info">
          {command}
        </Alert>
      )}
      {!disabled && command && cmds.length > 0 && (
        <TableBox>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="none" align="center">
                  봇 정보
                </TableCell>
                <TableCell padding="none" align="center">
                  명령어
                </TableCell>
              </TableRow>
            </TableHead>
            {cmds &&
              cmds.map(({ id, title: t, example }) => (
                <TableBody key={id}>
                  <TableRow sx={{ cursor: 'pointer' }}>
                    <TableCell size="small" sx={{ textAlign: 'center' }}>
                      <TableAvatar
                        {...{
                          type: 'icon',
                          uuid: id,
                          sx: { m: 'auto' },
                          variant: 'square',
                        }}
                      />
                      <Typography>{t}</Typography>
                    </TableCell>
                    <TableCell size="small">
                      {example &&
                        example.map((str) => (
                          <Button
                            type="button"
                            variant="contained"
                            id={id}
                            name={`${CAL_REGISTER_FIELD_CMD}-${CAL_REGISTER_FIELD_CMD_TOGGLE}`}
                            key={str}
                            value={`${id}_${str}`}
                            onKeyPress={onChange}
                            onClick={onChange}
                            className="cmd-example-button"
                          >
                            {str}
                          </Button>
                        ))}
                    </TableCell>
                  </TableRow>
                </TableBody>
              ))}
          </Table>
        </TableBox>
      )}
    </>
  );
};
export default CalendarCmdSwitch;
